import type { Catalog } from '..'

export const stage: Catalog['stage'] = {
  /* the tool rail */
  canvasTools: 'Ferramentas do canvas',
  toolTooltip: '{label} ({key})',
  canvasMode: 'Modo do canvas',
  modeEdit: 'Modo de edição',
  modePrototype: 'Modo protótipo: conecte interações',
  modeComment: 'Modo comentário (C)',
  hintPath: 'Clique para cantos · Arraste para curvas · Encaixa nos pontos · Enter para concluir',
  hintText: 'Clique ou arraste e digite · {mod}Enter para salvar',
  hintCircle: 'Arraste para desenhar um círculo · Esc para cancelar',
  hintShape: 'Arraste para desenhar · Shift para um quadrado · Esc para cancelar',
  finishPath: 'Concluir caminho',
  newFrame: 'Novo frame',

  /* drawing, path editing, moving and resizing */
  textInputLabel: 'Texto a adicionar ao canvas',
  textPlaceholder: 'Digite algo…',
  pathHandleIncoming: 'Alça de entrada do ponto {n}',
  pathHandleOutgoing: 'Alça de saída do ponto {n}',
  pathPoint: 'Ponto {n} do caminho',
  savingPath: 'Salvando caminho…',
  pathHint: 'Arraste pontos ou alças · clique no contorno para adicionar um ponto · Alt para soltar o encaixe',
  makeCorner: 'Tornar canto',
  makeCurve: 'Tornar curva',
  deletePoint: 'Excluir ponto',
  done: 'Concluir',
  movingDrawing: 'Movendo desenho',
  resize: 'Redimensionar',
  resizeWidth: 'Redimensionar largura',
  resizeHeight: 'Redimensionar altura',
  rulerHorizontal: 'Régua horizontal: arraste para baixo para adicionar uma guia',
  rulerVertical: 'Régua vertical: arraste para a direita para adicionar uma guia',
  guideRemove: 'Remover',

  /* a frame on the canvas */
  moveElementFailed: 'Não foi possível mover o elemento',
  elementGone: 'Este elemento não existe mais. Mostrando o frame dele.',
  lockedTip: 'Bloqueado — desbloqueie no painel Camadas ou no Inspetor',
  syncedTip: 'Sincronizado de um app ao vivo',
  githubPlaceholderTip: 'Encontrado no repositório — aguardando captura',
  githubImportedTip: 'Importado de um repositório do GitHub',
  isDesigning: '{name} está desenhando',
  isOnIt: '{name} está cuidando disso',
  elementComment: 'Comentar',
  askAi: 'Pedir à IA',
  code: 'Código',
  editText: 'Editar texto',
  textFormatting: 'Formatação de texto',
  textBold: 'Negrito',
  textItalic: 'Itálico',
  textUnderline: 'Sublinhado',
  textStrikethrough: 'Tachado',
  textBulletList: 'Lista com marcadores',
  textNumberedList: 'Lista numerada',
  frameChanged: 'O frame mudou. Clique com o botão direito de novo.',
  findingElement: 'Procurando elemento…',

  /* the frame and element menus */
  paste: 'Colar',
  copyClipboardFailed: 'Não foi possível copiar para a área de transferência. Tente novamente.',
  duplicate: 'Duplicar',
  show: 'Mostrar',
  hide: 'Ocultar',
  lock: 'Bloquear',
  unlock: 'Desbloquear',
  copyHtml: 'Copiar HTML',
  copySelector: 'Copiar seletor',
  copyLink: 'Copiar link',
  copyLinkToElement: 'Copiar link do elemento',
  exportPng: 'Exportar como PNG',
  exportJpg: 'Exportar como JPG',
  moveUp: 'Mover para cima',
  moveDown: 'Mover para baixo',
  deleteElement: 'Excluir elemento',
  deleteFrame: 'Excluir frame',
  copyFrames: 'Copiar {count} frames',
  duplicateFrames: 'Duplicar {count} frames',
  showFrames: 'Mostrar {count} frames',
  hideFrames: 'Ocultar {count} frames',
  lockFrames: 'Bloquear {count} frames',
  unlockFrames: 'Desbloquear {count} frames',
  deleteFrames: 'Excluir {count} frames',
  framesCount: '{count} frames',
  copyAsPng: 'Copiar como PNG',
  copyImageUrl: 'Copiar URL da imagem',
  imageUrlCopied: 'URL da imagem copiada',
  copyImageUrlFailed: 'Não foi possível copiar a URL da imagem',
  exportEllipsis: 'Exportar…',
  versionHistory: 'Histórico de versões…',
  markReadyForDev: 'Marcar como pronto para dev',
  moveToDraft: 'Voltar para rascunho',

  /* approval */
  readyForDev: 'Pronto para dev',
  needsReview: 'Precisa de revisão',
  approvedByOn: 'Aprovado por {name} em {date}',
  previouslyApprovedByOn: 'Aprovado anteriormente por {name} em {date}',
  markAsApproved: 'Marcar como aprovado',
  approvalReady: 'Os agentes podem ver que esta tela está aprovada para implementação.',
  approvalChanged: 'Este design mudou depois da aprovação. Revise-o antes de marcá-lo como pronto de novo.',
  approvalPrompt: 'Aprove esta tela para avisar sua equipe e os agentes que ela está pronta para ser construída.',
  saving: 'Salvando…',
  approvalWait: 'Aguarde as alterações terminarem de salvar antes de aprovar.',

  /* comments */
  commentOnElement: 'Deixe um comentário neste elemento…',
  commentOnFrame: 'Deixe um comentário neste frame…',
  commentHere: 'Deixe um comentário aqui…',
  pinReplies: { one: ' ({count} resposta)', other: ' ({count} respostas)' },
  willPickUp: '{name} vai cuidar disso',
  post: 'Publicar',
  agentStopped: '{name} parou',
  waitingFor: 'aguardando {name}',
  agentDidNotFinish: 'O agente não terminou.',
  retry: 'Tentar de novo',
  replyAskAgent: 'Responder… (@doop para chamar o agente)',
  replyEllipsis: 'Responder…',
  replyFailed: 'Essa resposta não foi enviada — talvez a conversa já esteja resolvida. Tente de novo.',
  resolve: 'Resolver',
  posting: 'Publicando…',
  reply: 'Responder',
  noComments:
    'Ainda não há comentários nesta página. Use a ferramenta de comentário ou clique com o botão direito em um elemento para deixar um.',
  commentFilter: 'Filtro de comentários',
  filterOpen: 'Abertos',
  filterResolved: 'Resolvidos',
  noOpenThreads: 'Nenhuma conversa aberta nesta página.',
  noResolvedThreads: 'Nenhuma conversa resolvida nesta página.',
  goToFrame: 'Ir para “{name}”',
  goToPin: 'Ir para o marcador no canvas',
  resolvedBy: 'resolvido por {name}',
  replies: { one: '{count} resposta', other: '{count} respostas' },
  resolvedReplies: 'Respostas resolvidas',
  replyPanelPlaceholder: 'Responder… @doop para chamar o agente',
  replyTo: 'Responder a {name}',
  markResolved: 'Marcar esta conversa como resolvida',

  /* PostHog heatmap */
  posthogShowClicks: 'Mostrar mapa de calor de cliques do PostHog',
  posthogShowRageClicks: 'Mostrar cliques de raiva do PostHog',
  posthogHide: 'Ocultar mapa de calor do PostHog',
  posthogReadThisFar: '{percent}% dos visitantes leram até aqui',
  posthogClicksCaption: {
    one: 'PostHog · {count} clique · {days} dias',
    other: 'PostHog · {count} cliques · {days} dias',
  },
  posthogRageCaption: {
    one: 'PostHog · {count} clique de raiva · {days} dias',
    other: 'PostHog · {count} cliques de raiva · {days} dias',
  },
  posthogNoClicks: 'O PostHog não tem cliques em {page} com uma largura parecida em {days} dias',
  posthogNoRageClicks: 'O PostHog não tem cliques de raiva em {page} com uma largura parecida em {days} dias',
  posthogHeatmapFailed: 'Não foi possível carregar o mapa de calor do PostHog',
}
